import * as React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Tooltip} from "reactstrap";
import MediaInfoList from "./mediaInfoList";

function MediaInfos() {

	return (
		<Row className="animated fadeIn">
			<Col>
				<Card>
					<CardHeader>
						<div className="direction-group">
							<div className="direction-left d-flex justify-content-start">
								<h2 className="float-left mr-4">
									Informacje prasowe
								</h2>
							</div>
						</div>
					</CardHeader>
					<hr className="my-0" />
					<CardBody>
						<Row>
							<Col>
								<MediaInfoList />
							</Col>
						</Row>
					</CardBody>
				</Card>
			</Col>
		</Row>
	)
}

export default MediaInfos;